export default __webpack_public_path__ + "static/media/lain_speak_intro.43463517.png";